var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_vm._v(" "+_vm._s(_vm.$t('Redirecting'))+"... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }